import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WS_URL = `${BACKEND_URL.replace(/^http/, "ws")}/api/ws`;

const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (detail && typeof detail === "object" && detail.message) return detail.message;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export async function openInvoicePdf(id) {
  const { data } = await api.get(`/invoices/${id}/pdf`, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

// Fichier de l'API (justificatif, export PDF des dépenses — lot 20) : lu avec le jeton dans l'en-tête (plus
// de ?auth= dans les adresses), puis affiché via une adresse blob dans un nouvel onglet. L'onglet est ouvert
// AVANT la lecture : ouvert après, un téléphone le bloquerait comme fenêtre surgissante.
export const openFileInTab = (path) => openInTab(`/files/${path}`);

export async function openInTab(apiPath, params) {
  const tab = window.open("", "_blank");
  try {
    const { data } = await api.get(apiPath, { params, responseType: "blob" });
    const url = URL.createObjectURL(data);
    if (tab) tab.location.href = url; else window.open(url, "_blank");
    setTimeout(() => URL.revokeObjectURL(url), 5 * 60000);
  } catch (e) {
    if (tab) tab.close();
    throw e;
  }
}

export default api;
